import React, { useContext, useState } from 'react'
import styled from 'styled-components'
import {
  BackgroundImage,
  Box,
  Button,
  Card,
  Flex,
  Text
} from 'pcln-design-system'
import { LogoPricelineVip } from '@pcln/vip'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import BootstrapDataContext from '@/context/BootstrapDataContext'
import VIPPromoSrc from '@/images/promos/hotel-vip-promo-2x.jpg'
import CONTENT from '@/constants/content'
import PromoModal from '../Modal/PromoModal'
import { handleSubmitForVIPDeals } from '../../Hotels/SearchForm/utils'
import { PromoDeal } from '../../Hotels/constants'

const FlexImgWrapper = styled(Flex)`
  ${props => props.theme.mediaQueries[0]} {
    flex: 1 1 50%;
  }
  ${props => props.theme.mediaQueries[3]} {
    flex: 1 1 33%;
  }
`

const FlexHeaderContentWrapper = styled(Flex)`
  flex-direction: column;
  margin-bottom: 16px;
  ${props => props.theme.mediaQueries[3]} {
    flex: 1 1 50%;
  }
  @media screen and (min-width: 1440px) {
    margin-bottom: 24px;
  }
`

const VIPBackgroundImage = styled(BackgroundImage)<{
  isMobile: boolean
}>`
  width: 100%;
  background-color: transparent;
  background-position: top;
  border-top-left-radius: 16px;
  border-bottom-left-radius: ${props => (props.isMobile ? '0px' : '16px')};
  border-top-right-radius: ${props => (props.isMobile ? '16px' : '0px')};
  @media only screen and (max-width: 1023px) {
    border-top-right-radius: 16px;
    border-bottom-left-radius: 0px;
  }
  height: ${props => (props.isMobile ? '109px' : 'inherit')};
`

const Wrapper = styled(Card)`
  min-height: 250px;
  background-color: white;
`

const StyledLogoPricelineVip = styled(LogoPricelineVip)`
  font-size: 32px;
  height: 32px;
  line-height: 1;
  margin-bottom: 8px;
  ${props => props.theme.mediaQueries[3]} {
    font-size: 48px;
    height: 48px;
    margin-bottom: 12px;
  }
`
const DealButton = ({ handleModalOpen }: { handleModalOpen: () => void }) => (
  <Button
    style={{ width: '160px' }}
    size="medium"
    onClick={() => {
      analytics.fireEvent({
        category: ANALYTICS_CATEGORY_HOME,
        action: 'Feature Box CTA',
        label: 'Search VIP Deals'
      })
      handleModalOpen()
    }}
    aria-label="VIP Promo button"
    role="button"
  >
    Search VIP Deals
  </Button>
)

export default function VIPPromo({ isMobile = false }: { isMobile?: boolean }) {
  const {
    customer: { firstName }
  } = useContext(BootstrapDataContext)
  /**
   * TODO: Add these values to contentful and add fallback values
   */
  const headlineVIP = firstName
    ? CONTENT.homepage.vip.promo.headlineWithName.replace(
        '{firstName}',
        firstName
      )
    : CONTENT.homepage.vip.promo.headline
  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <Wrapper
      boxShadowSize="md"
      mx={[0, null, 2]}
      mb={[4, null, 0]}
      borderRadius="xl"
      borderWidth={0}
      width={[1, null, 2 / 3]}
    >
      <Flex
        flexDirection={['column', null, null, null, 'row']}
        style={{ height: '100%' }}
      >
        <FlexImgWrapper>
          <VIPBackgroundImage
            image={`${VIPPromoSrc}?opto&auto=webp`}
            isMobile={isMobile}
          />
        </FlexImgWrapper>
        <Box p={3} width={[1, null, null, null, 2 / 3]}>
          <StyledLogoPricelineVip variation="vip" />
          <FlexHeaderContentWrapper>
            <Text
              color="text.heading"
              fontSize={[3, null, null, null, '22px', 4]}
              mb={2}
              fontWeight="bold"
              textStyle="heading3"
              lineHeight="display"
              className={firstName ? 'fs-mask' : null}
            >
              {headlineVIP}
            </Text>
            <Text color="text" lineHeight="display" textStyle="subheading6">
              {CONTENT.homepage.vip.promo.subHeadline}
            </Text>
          </FlexHeaderContentWrapper>
          <DealButton
            handleModalOpen={() => {
              setModalOpen(true)
            }}
          />
        </Box>
      </Flex>
      <PromoModal
        ariaLabel="VIP Deals Search Modal"
        primaryText="Search VIP Deals"
        secondaryText="Save more as a Priceline VIP"
        isMobile={isMobile}
        isModalOpen={isModalOpen}
        onSubmit={handleSubmitForVIPDeals}
        onClose={() => {
          setModalOpen(false)
        }}
        promoDeal={PromoDeal.VIP}
      />
    </Wrapper>
  )
}
